import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { useAuth } from '@features/auth'
import useClearCartModal from '@features/cart/hooks/useClearCart'
import { useCartStore } from '@features/cart/model/useCartStore'
import { useErrorInfoModal } from '@features/modal'
import { useAddressStore } from '@features/shipping-methods'

import { useClearCartMutation } from '@shared/generated'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'



export default function ClearCartModal () {
  const { t: tc } = useTranslation('common')
  const { clearCart } = useCartStore()
  const { openErrorInfoModal } = useErrorInfoModal()
  const { closeClearCartModal } = useClearCartModal()
  const { isAuthorized } = useAuth()
  const [ fetchClearCart ] = useClearCartMutation()
  const { shopId } = useAddressStore()

  const isTablet = useMediaQuery('(max-width: 768px)')
  const buttonSize = isTablet ? 'medium' : 'large'

  const handleClearCart = async () => {
    if (isAuthorized) {
      try {
        await fetchClearCart({
          variables: {
            shopId,
          },
        })

        clearCart()
      }
      catch (error) {
        console.error('fetchClearCart error: ', error)
        openErrorInfoModal({
          description: tc('clear_cart'),
        })
      }
    }
    else {
      clearCart()
    }

    closeClearCartModal()
  }

  return (
    <div className={styles.modal}>
      <Button onClick={handleClearCart} size={buttonSize}>
        {tc('yes')}
      </Button>
      <Button onClick={closeClearCartModal} theme="grey" size={buttonSize}>
        {tc('no')}
      </Button>
    </div>
  )
}
